import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Form, Row, Spin } from "antd";
import { PlusCircleFilled } from "@ant-design/icons";
//Components
import { ModalExpLaboral } from "../../../components/Admin/Aspirante";
import { HisExpLaboral } from "../../../components/Admin/Aspirante";
//Ducks
import * as catalogo from "../../../redux/aspirante/catalogoDucks";
import * as ducks from "../../../redux/aspirante/expLaboralDuck";
//utils
import * as utils from "../../../utils";
import { ReactComponent as Indicaciones } from "../../../assets/img/admin/IndicaciónInfoLab.svg";
import './ExperienciaPage.css';

/**
 * Pantalla que muestra y captura la experiencia del aspirante.
 * @returns JSX.Element
 */
export const ExperienciaPage = () => {
    const dispatch = useDispatch();
    //Hook para controlar el modal
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const { expLaboral, loading } = useSelector((state) => state.expLaboral);
    const [actFechaFin, setActFechaFin] = useState(false);
    const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
    const { estatusPostulacion } = useSelector(
        (state) => state.bloqueoEstatus.concurso
    );
    const isMounted = useRef(true);
    const { isSaved, isError, mensaje } = useSelector(
        (state) => state.expLaboral.statusForm
    );

    //Se cargan los catalogos
    useEffect(() => {
        dispatch(catalogo.getRemuneraciones());
        dispatch(catalogo.getAreasExperiencia());
        dispatch(ducks.getExpLaboralById());
        dispatch(ducks.isActiveExpLaboral({}));
        // eslint-disable-next-line
    }, []);

    //useEffect que valida si hubo un error al registrar el aspirante o se guardó correctamente.
    useEffect(() => {
        isMounted.current && validaFormulario();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isError, isSaved, mensaje]);

    const validaFormulario = () => {
        if (isSaved) {
            //Si todo se guardo correctamente
            utils.nextTabConfirm(mensaje, utils.TAB_EXP_LABORAL, "4", dispatch);
            form.resetFields();
            showModal();
        }
        if (isError) {
            utils.openModalError(utils.ERROR, mensaje); //Si hubo un error al momento de registrar
        }
        dispatch(ducks.setFormularioClean());
    };

    /**
     * Función para mostrar/ocultar el modal de registro
     */
    const showModal = () => {
        setIsModalVisible((state) => !state);
        setActFechaFin(false);
    };

    return (
        <Spin size="large" spinning={loading}>
            {/* Modal del formulario de nueva experiencia */}
            <ModalExpLaboral
                isModalVisible={isModalVisible}
                showModal={showModal}
                form={form}
                actFechaFin={actFechaFin}
                setActFechaFin={setActFechaFin}
            />

            <div className="site-layout-content">
                <div className="contenedorExperiencia">
                    {/* Historial Experiencia */}
                    {expLaboral !== undefined && expLaboral.length > 0 && (
                        <div className="mt-20">
                        <HisExpLaboral
                            showModal={showModal}
                            form={form}
                            setActFechaFin={setActFechaFin}
                        />
                        </div>
                    )}

                    {/* Sin Datos */}
                    {(expLaboral === undefined || expLaboral.length === 0) && (
                        <>
                            <div className="contenedorIndicaciones">
                                <div className="contenedorIndicacionesImg">
                                    <Button type="primary" shape="circle" icon={<Indicaciones />}  />
                                </div>
                                <div className="contenedorIndicacionesText">
                                    Presiona <b>“Agregar nueva experiencia”</b> para comenzar a agregar información de tu historial laboral.
                                </div>
                            </div>
                            <div className="mt-50">
                                <Button
                                type="link"
                                icon={<PlusCircleFilled />}
                                disabled={bloquearPorFecha || estatusPostulacion}
                                className="btn-nuevo"
                                onClick={showModal}
                                >
                                {/* <span className="btn-nuevo" onClick={showModal}> */}
                                Agregar nueva experiencia
                                {/* </span> */}
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Spin>
    );
};

export const SinDatos = () => (
    <Row gutter={24}>
        <div className="contenedor-sin-datos">
        <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={6}>
            <Indicaciones width={"100%"} />
        </Col>
        <Col xxl={21} xl={21} lg={21} md={21} sm={24} xs={24}>
            <div className="text-sin-datos">
            Presiona <b>“Agregar nueva experiencia”</b> para comenzar a agregar
            información de tu historial laboral.
            </div>
        </Col>
        </div>
    </Row>
);
